// 项目全局配置文件

const QZ_CONFIG = {
  OSS_IMG_HOST: 'https://staticqn.qizuang.com/', // 静态资源
  QZ_WEB_HOST: 'https://www.qizuang.com/',
  OSS_VIDEO_HOST_UPLOAD: 'http://upload.qiniu.com/', // 视频上传，直传服务器 只能通过http上传
  ZXS_IMG_HOST: 'https://zxsqn.qizuang.com/', // 上传图片服务器
  CP_OLD_BASE: 'https://cp.qizuang.com',
  CP_OLD_PATH_PASSWORD: '/getpassword/',
  BAIDU_MAP_AK: 'iZV7CPYuc6FG6sIgxDT4PLFBWLfXKtO7',
};
if(process.env.NODE_ENV === 'uat'){
  // uat 环境(测试)
  QZ_CONFIG.OSS_AUDIO_HOST = '//uat-ygjapi.qizuang.net/'
}else if(process.env.NODE_ENV === 'development'){
  // dev 环境（开发)
  QZ_CONFIG.OSS_AUDIO_HOST = '//dev-ygjapi.qizuang.net/'
}else if(process.env.NODE_ENV === 'production'){
  // prd 环境(生产)
  QZ_CONFIG.OSS_AUDIO_HOST = '//ygjapi.qizuang.com/'
}
export default QZ_CONFIG;
